import { BaseDevice } from '@/profiles/base_device'
import { CustomLayout } from '../../base_device'
import list_icon from '@/assets/img/device/nd68_2/list_icon.png'
import { DevicePid, EffectIndex, KK, VK } from '@/define/define'
import { getDeviceKeySquare } from '../keysquare/keysquare'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { LIGHT_EFFECT_LIST_ND68 } from '../../light/light_effect_list'
import { generateArray } from '@/tool/utility'
import { mu68VKCodes } from '../keycode/vkeycode'
export class ND68 extends BaseDevice {
  magneticAxis: boolean = true
  speedAllowValues: number[] = [4, 3, 2, 1, 0]
  lightAllowValues: number[] = generateArray(0, 5)

  minDelayTimer: number = 1
  maxDelayTimer: number = 60000

  name: string = 'ND68'
  icon: string = list_icon
  width: number = 700
  square = getDeviceKeySquare(DevicePid.CarotmasMars68)
  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_ND68
  inoperableKeys: KK[] = [0x41]
  fnDisableKeys: KK[] = [0x1, 0x7, 0xd, 0x13, 0x19, 0x1f, 0x25, 0x2b, 0x31, 0x37, 0x3d, 0x43, 0x49, 0x4f, 0x44, 0x4a, 0x9, 0xf, 0xb, 0x59, 0x5e, 0x5f, 0x52, 0x4d, 0x53, 0x65, 0x3b, 0x11]
  customLayout: CustomLayout = {
    0x4f: this.createSquare(2, 2, 81),
    0x2: this.createSquare(2, 2, 54),
    0x50: this.createSquare(2, 2, 64),
    0x56: this.createSquare(2, 2, 36),
    0x3: this.createSquare(2, 2, 64),
    0x51: this.createSquare(2, 2, 92),
    0x4: this.createSquare(2, 2, 76),
    0x4c: this.createSquare(2, 2, 80),
    0x5: this.createSquare(2, 2, 48),
    0xb: this.createSquare(2, 2, 48),
    0x17: this.createSquare(2, 2, 48),
    0x11: this.createSquare(2, 2, 48),
    0x29: this.createSquare(2, 2, 239),
  }
  // rate: number[] = [8, 4, 2, 1, 0.5, 0.25, 0.125]
  superResponse: boolean = false
  vkcodes = mu68VKCodes
  adjustRTStabilization: number[] = [0, 25, 50, 75, 100]
  touchGuard = true
  rate: number[] = [8, 1]
}
